// extracted by mini-css-extract-plugin
module.exports = {"features":"Features_features__JcQ80","footer":"Features_footer__45JGw"};